import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { ResourceManager } from '../../../core/resource-manager';
import courseDefault from '../../../assets/course.jpg';




export default function CardCorso({ data }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);


    useEffect(() => {
        console.log('data-card', data)
        setImage(data.image ? ResourceManager.getFileUrl(data.image, 'course') : courseDefault)

    }, []);

    function clickAction() {
        navigate('/corsi/' + data.id)
    }


    if (data) {
        return (
            <Card role="button" onClick={clickAction} className='my-3 text-dark h-100' style={{ borderRadius: '20px' }}>
                <Card.Img className='image-hover' variant="top" src={image} style={{ borderStartEndRadius: '20px', borderStartStartRadius: '20px' }} />
                {/* <Card.ImgOverlay>
                    <Card.Title className='text-white'>
                        <h5>{data && data.name}</h5>
                    </Card.Title>
                </Card.ImgOverlay> */}
                <Card.Body>
                    <Card.Text>
                        <small>Corsi | {data && data.idCategory && data.idCategory.name}</small>
                    </Card.Text>
                    {/* <Card.Text style={{ minHeight: '70px' }}>
                        {data && data.description && (
                            <>
                                <span dangerouslySetInnerHTML={{__html: data && data.description.length > 110 ? data.description.substring(0, 110) + '...' : data.description}}></span>
                            </>
                        )}
                    </Card.Text> */}
                    <Card.Text style={{ minHeight: '70px' }}>
                        <h5>{data && data.name}</h5>
                    </Card.Text>
                    <Card.Text>
                        <Badge bg='light' pill className='text-black me-2'><small>{data && data.episodes && data.episodes.length} lezioni</small></Badge>
                        <Badge bg='light' pill className='text-black me-2'>
                            <small>{data.estimatedTime ? data.estimatedTime : 0} ore</small>
                        </Badge>
                        {/* <Badge bg='light' pill className='text-black me-2'><small>{data && data.episodes && data.episodes.reduce((acc, cur) => acc + cur.points, 0)} eLearning Points</small></Badge> */}
                    </Card.Text>
                </Card.Body>
            </Card>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};